import React, { useContext, useEffect, useState } from 'react';
import './user-training-results.css'
import { Table, Pagination } from 'react-bootstrap';
// import Pagination from "react-bootstrap/Pagination";
import axios from "axios";
import { UserContext } from "../../UserContext";
import { useNavigate } from "react-router-dom";
import Spinner from "../spinner/spinner";
import translations from "../../translations";
import { LanguageContext } from "../../languageContext";
import { useToast } from "../../ToastContext";
import api from "../../api";

const UserTrainingResults = () => {
    const { addToast } = useToast();
    const SERVER_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/api/v1/"
        : "/api/v1/";
    const { user } = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese');
    const { language } = useContext(LanguageContext);
    const navigate = useNavigate();
    const itemsPerPage = 10; // Number of items per page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentData, setCurrentData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        if (user) {
            getSessions();
        }
    }, [user])

    useEffect(() => {
        setLangOpt(language);
    }, [language])

    const translate = (text) => {
        if (text) {
            return langOpt === 'Japanese' ? translations[text] : text;
        } else {
            return text
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        let total = Math.ceil(sessions.length / itemsPerPage);
        setTotalPages(total);
        let data = sessions.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
        );
        setCurrentData(data);
    }, [sessions, currentPage])

    const getSessions = async () => {
        try {
            setLoading(true)
            if (!user.userEmail) return addToast(translate("userEmail not found"), "error")
            const response = await api.get(`training/sessions?userEmail=${user.userEmail}&stage=COMPLETED`);
            if (response.status === 200 && response.data) {
                setSessions(response.data.data);
                setLoading(false)
            } else {
                console.error("Unexpected response:", response);
            }
        } catch (error) {
            console.error("Error fetching question:", error);
        }
    };

    const downloadPdf = async (id) => {
        const trainingSessionId = id; // replace with your dynamic session ID
        setLoading(true);
        const url = `history/historyPdf?trainingSessionId=${trainingSessionId}`;

            try {
                const response = await api.post(url,{},{ responseType: 'blob' });

                // Check if the response is successful
                if (response.status !== 200) {
                    throw new Error('Failed to fetch the PDF');
                }

                // Get the response as a Blob (binary data)
                const pdfBlob = response.data;

                // Create a link element to trigger the download
                const link = document.createElement('a');
                const urlObject = window.URL.createObjectURL(pdfBlob); // Create an object URL for the blob

                link.href = urlObject;
                link.download = 'history.pdf'; // Specify the name of the downloaded file
                document.body.appendChild(link);
                link.click(); // Simulate a click to trigger the download
                setLoading(false);

                // Clean up the object URL
                window.URL.revokeObjectURL(urlObject);
                document.body.removeChild(link);
            } catch (error) {
                setLoading(false);
                console.error('Error downloading PDF:', error);
            }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const navigateBack = () => {
        navigate(`/dashboard`);
    }

    const getResult = (correct, total) => {
        return correct / total >= 0.6 ? translate("Pass") : translate("Fail");
    };

    return (
        <>
            {loading && <Spinner />}
            <div className="training-result-container">
                <div className="result-container">
                    <div className="resultHeader">
                        <h2>{translate("View Training Results")}</h2>
                        <span className="header-tools"><img src="./cross.svg" alt="close-button" onClick={() => {
                            navigateBack()
                        }} /></span>
                    </div>
                    <div className="resultContent">
                        <Table striped bordered hover className="custom-table">
                            <thead>
                                <tr >
                                    <th>{translate("Date")}</th>
                                    <th>{translate("Score")}</th>
                                    <th>{translate("Result")}</th>
                                    <th>{translate("Result report")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentData.length !== 0 && currentData.map((session) => {
                                    return (
                                        <tr key={session.createdAt} >
                                            <td>{formatDate(session.createdAt)}</td>
                                            <td>{session.correctCount}/40</td>
                                            <td>{getResult(session.correctCount, 40)}</td>
                                            <td>
                                                {new Date(session.createdAt) > new Date("2025-01-30") ? (
                                                    <img
                                                        className="download-image"
                                                        src="./download.svg"
                                                        alt="download-image"
                                                        onClick={() => downloadPdf(session.id)}
                                                    />
                                                ) : (
                                                    "-" // Show a dash if the date is before or on 31/01/2025
                                                )}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                        <div className="pagination-container" style={{ 'display': "flex" }}>
                            <Pagination style={{ 'marginLeft': "auto", "fontSize": "12px" }}>
                                <Pagination.First
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange(1)}
                                />
                                <Pagination.Prev
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                />
                                {[...Array(totalPages)].map((_, index) => (
                                    <Pagination.Item
                                        key={index}
                                        active={index + 1 === currentPage}
                                        onClick={() => handlePageChange(index + 1)}
                                    >
                                        {index + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                />
                                <Pagination.Last
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange(totalPages)}
                                />
                            </Pagination>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserTrainingResults